<template lang="html">
  <ValidationProvider v-slot="{ errors }" :name="nameValidation" :rules="{ required: true, phoneNumber: { countryCode }}">
    <div class="v-input__control">
      <div :class="[`phone-number-input-wrapper`, { 'phone-error': errors[0] }]">
        <vue-phone-number-input v-model="phone" :translations="translations" default-country-code="ID" :preferred-countries="['ID', 'SG', 'MY']" color="#00CA96" no-example class="mb-1" @update="onUpdatePhoneNumber" />
      </div>
      <div class="v-text-field__details detail_custom">
        <div class="v-messages theme--light error--text" role="alert">
          <div class="v-messages__wrapper">
            <div class="v-messages__message">
              {{ errors[0] }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
export default {
  name: 'LAPhoneNumber',
  components: {
    ValidationProvider
  },
  props: {
    value: {
      default: '',
      type: [Number, String]
    },
    label: {
      default: '',
      type: String
    },
    nameValidation: {
      default: 'phone',
      type: String
    }
  },
  data() {
    return {
      dataPhone: {},
      countryCode: 'ID',
      translations: {
        countrySelectorLabel: '',
        countrySelectorError: '',
        phoneNumberLabel: this.label,
        example: ''
      }
    }
  },
  computed: {
    'phone': {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    'dataPhone'(newItem, oldItem) {
      if (newItem.isValid === true) {
        this.phone = newItem.e164
      }
    }
  },
  methods: {
    onUpdatePhoneNumber(payload) {
      this.countryCode = payload.countryCode
      this.dataPhone = { ...payload }
    }
  }
}
</script>

<style lang="css">
.input-tel.has-value .input-tel__label{
  font-size: 10px !important;
  top: 2px !important;
  line-height: normal !important;
}
.phone-number-input-wrapper .country-selector__input{
  padding-top: 1px !important;
  font-size: 16px !important;
  padding-right: 0px !important;
  border: 1px solid rgb(0, 202, 150);
}
.phone-number-input-wrapper .country-selector__toggle{
  display: none !important;
}
.phone-number-input-wrapper .country-selector__country-flag{
  top: 15px !important;
}
.phone-number-input-wrapper .select-country-container{
  flex: 0 0 80px !important;
  width: 80px !important;
  min-width: 80px !important;
  max-width: 80px !important;
}
.phone-number-input-wrapper .input-tel__input{
  padding-top: 1px!important;
  font-size: 16px !important;
  border: 1px solid rgb(0, 202, 150);
}
.phone-error .input-tel__input, .phone-error .country-selector__input{
  border: solid 2px #ff5252 !important;
}
.phone-error .country-selector__input{
  border-right: 0px !important;
}
.v-text-field__details.detail_custom{
  padding: 0 12px;
  margin-bottom: 8px;
}
.input-tel.input-phone-number.is-valid > input, .country-selector.input-country-selector.is-valid > input{
  border-color: #1a73e8 !important;
  box-shadow: none !important;
}
.input-tel.input-phone-number.has-error > input, .country-selector.input-country-selector.has-error > input{
  border-color: #ff5252 !important;
  box-shadow: none !important;
  border: solid;
}
.input-tel.input-phone-number.is-focused > input, .country-selector.input-country-selector.is-focused > input{
  border: solid;
  box-shadow: none !important;
}
</style>
